


<div class="row ">
    <div class="col ps-3">
        <h4 class="mb-0 font-header" style="font-weight: 700;">Eligibility Logs</h4>
    </div>
</div>
<div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId==0">
    <div class="row mt-4 ">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                            agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="row mb-2 mt-2"
    *ngIf=" global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!=0">
    <div class="col">
        <div class="card-body  widget-body pb-0 pt-2 mb-3">
        </div>
        <div widget class="card border-0 box-shadow" style="min-height: 500px;">
            <section id="tabs" class="project-tab">
                <div class="w-100">
                  <div class="row">
                    <div class="col-12">
                      <nav style="height: 50px; margin: 20px; ">
                        <!-- Tab Navigation -->
                        <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                          <a 
                            class="nav-item nav-link active" 
                            id="nav-270-tab" 
                            data-bs-toggle="tab" 
                            data-bs-target="#nav-270" 
                            href="#nav-270"
                            role="tab" 
                            aria-controls="nav-270" 
                            aria-selected="true" 
                            (click)="view271client = false">
                            270 Logs
                          </a>
                          <a 
                            class="nav-item nav-link" 
                            id="nav-271-tab" 
                            data-bs-toggle="tab" 
                            data-bs-target="#nav-271" 
                            href="#nav-271"
                            role="tab" 
                            aria-controls="nav-271" 
                            aria-selected="false" 
                            (click)="view271client = true">
                            271 Logs
                          </a>
                        </div>
                      </nav>
              
                      <!-- Tab Content -->
                      <div class="tab-content " id="nav-tabContent" style="margin: 9px;">
                        <!-- Tab Pane 1 -->
                        <div 
                          class="tab-pane fade show active" 
                          id="nav-270" 
                          role="tabpanel" 
                          aria-labelledby="nav-270-tab" 
                          *ngIf="global.globalAgencyId !== '00000000-0000-0000-0000-000000000000'">
                          <div class="row mt-2 ms-2">
                            <div class="col-lg-3">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">From<sup class="super-script">*</sup> </label>
                                </div>
                                <div class="col-lg-12">
                                    <my-date-picker [options]="myDatePickerOptions" [selDate]="FilterDates.FromDate" placeholder="mm/dd/yyyy"
                                        (inputFieldChanged)="newdates($event,'inputchanged','FromDate')"
                                        (dateChanged)="newdates($event,'datechanged','FromDate')">
                                    </my-date-picker>
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">To<sup class="super-script">*</sup></label>
                                </div>
                                <div class="col-lg-12">
                                    <my-date-picker  [options]="myDatePickerOptions" [selDate]="FilterDates.ToDate" placeholder="mm/dd/yyyy" [disabled]="FilterDates.FromDate==null||
                                    FilterDates.FromDate==undefined|| FilterDates.FromDate==''"
                                        (inputFieldChanged)="newdates($event,'inputchanged','ToDate')"
                                        (dateChanged)="newdates($event,'datechanged','ToDate')">
                                    </my-date-picker>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">File Status </label>
                                </div>
                                <div class="col-lg-12">
                                    <select [(ngModel)]="FilterDates.edi_Status" class="form-control">
                                        <option value="">All</option>
                                        <option value="Success">Success</option>
                                        <option value="Failed">Failed</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">Transaction Status </label>
                                </div>
                                <div class="col-lg-12">
                                    <select [(ngModel)]="FilterDates.transaction_Status" class="form-control">
                                        <option value="">All</option>
                                        <option value="Success">Success</option>
                                        <option value="Failed">Failed</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold"></label>
                                </div>
                                <div class="col-lg-12 ">
                                    <button type="button" class="btn blue-btn btn-sm ms-2" [disabled]="FilterDates.FromDate==null || FilterDates.FromDate==undefined ||
                                    FilterDates.FromDate=='' ||
                                    FilterDates.ToDate==null || FilterDates.ToDate==undefined ||
                                    FilterDates.ToDate==''
                                    " (click)="ApplyFilter()">Apply
                                    </button>
                                  
                                </div>
                            </div>
                        </div>
                        <div class="card-body  widget-body pt-2 " >
                            <ejs-grid #gridEligibilityLogs [dataSource]='GridDataList | async' [allowResizing]='true'
                                [allowSorting]='true' allowPaging='true' [allowFiltering]='true' (resizeStop)="onResize($event)"
                                [pageSettings]='initialPage' [filterSettings]='filterSettings'
                                (dataStateChange)='dataStateChange($event)' (actionBegin)="onActionComplete($event)"
                                [showColumnChooser]='true'>
                                <e-columns>
                                    <!-- 1.checkbox -->
                                    <!-- <e-column type="checkbox" uid="checkbox" maxWidth="50" width="50" textAlign="center"
                                        [allowEditing]="true"  [showInColumnChooser]="false">
                                    </e-column> -->
                                    <!-- Company -->
                                    <e-column field="fileName" headerText="File Name" width=150 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox ></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="group" headerText="Group" width=150 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox ></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- Status -->
                                    <e-column field="payer" headerText="Payor" width=150 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox ></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <!-- TransactionId -->
                                    <e-column field="companyName" headerText="Company Name" width=150 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox ></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="clearingHouse" headerText="Clearing house" width=150 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox ></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="edI_Status" headerText="File Status" width=150 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox ></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="ediError" headerText="File Error" width=150 type="string">
                                        <ng-template #template let-data>
                                            <button class="btn btn-edit-table text-center" data-bs-toggle="modal"
                                                *ngIf="data.ediError !=null && data.ediError !=undefined && data.ediError !=''"
                                                data-bs-target="#showError"
                                                (click)="getError(data.ediError)">View</button>&nbsp;
                                        </ng-template>
                                    </e-column>    
                                    <e-column field="transactionDateTime" headerText="Transaction date" width=150 type="date" [format]='formatOptions'>                                      
                                    </e-column>                                    
                                    <e-column field="transaction_status" headerText="Transaction Status" width=150 type="string" >
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox ></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="sftpError" headerText="SFTP Error" width="150"
                                            textAlign='center' [allowEditing]='false' type='string' [allowSorting]='false'
                                            [allowFiltering]="false">
                                            <ng-template #template let-data>
                                                <button class="btn btn-edit-table text-center" data-bs-toggle="modal"
                                                    *ngIf="data.sftpError!=null && data.sftpError!=undefined && data.sftpError!=''"
                                                    data-bs-target="#showError"
                                                    (click)="getError(data.sftpError)">View</button>&nbsp;
                                            </ng-template>
                                        </e-column>                       
                                    <!--------------------------------table header icon---------------->
                                    <e-column width="50" [showInColumnChooser]='false'>
                                        <ng-template #headerTemplate let-data>
                                            <div>
                                                <span id='show' (click)='showorhidecolumns()'><i class="fa fa-cog fa-lg"
                                                        aria-hidden="true"> </i></span>
                                            </div>
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                            <div *ngIf="EligibilityData.length == 0  && global.globalAgencyId != 0" class="text-center"
                                style="color:red">
                                <p>No data available</p>
                            </div>
                        </div>
                        </div>
              
                        <!-- Tab Pane 2 -->
                        <div 
                          class="tab-pane fade" 
                          id="nav-271" 
                          role="tabpanel" 
                          aria-labelledby="nav-271-tab">
                          <div class="row mt-2 ms-2">
                            <div class="col-lg-3">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">From<sup class="super-script">*</sup> </label>
                                </div>
                                <div class="col-lg-12">
                                    <my-date-picker [options]="myDatePickerOptions" [selDate]="Filter271.FromDate" placeholder="mm/dd/yyyy"
                                        (inputFieldChanged)="newdates271($event,'inputchanged','FromDate')"
                                        (dateChanged)="newdates271($event,'datechanged','FromDate')">
                                    </my-date-picker>
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">To<sup class="super-script">*</sup></label>
                                </div>
                                <div class="col-lg-12">
                                    <my-date-picker  [options]="myDatePickerOptions" [selDate]="Filter271.ToDate" placeholder="mm/dd/yyyy" [disabled]="Filter271.FromDate==null||
                                    Filter271.FromDate==undefined|| Filter271.FromDate==''"
                                        (inputFieldChanged)="newdates271($event,'inputchanged','ToDate')"
                                        (dateChanged)="newdates271($event,'datechanged','ToDate')">
                                    </my-date-picker>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">File Status </label>
                                </div>
                                <div class="col-lg-12">
                                    <select [(ngModel)]="Filter271.edi_Status" class="form-control">
                                        <option value="">All</option>
                                        <option value="Success">Success</option>
                                        <option value="Failed">Failed</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">Transaction Status </label>
                                </div>
                                <div class="col-lg-12">
                                    <select [(ngModel)]="Filter271.transaction_Status" class="form-control">
                                        <option value="">All</option>
                                        <option value="Success">Success</option>
                                        <option value="Failed">Failed</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold"></label>
                                </div>
                                <div class="col-lg-12 ">
                                    <button type="button" class="btn blue-btn btn-sm ms-2" [disabled]="Filter271.FromDate==null || Filter271.FromDate==undefined ||
                                    Filter271.FromDate=='' ||
                                    Filter271.ToDate==null || Filter271.ToDate==undefined ||
                                    Filter271.ToDate==''
                                    " (click)="ApplyFilter271()">Apply
                                    </button>
                                  
                                </div>
                            </div>
                        </div>
                        <div class="card-body  widget-body pt-2">
                            <ejs-grid #gridEligibility271 [dataSource]='GridData271 | async' [allowResizing]='true'
                                [allowSorting]='true' allowPaging='true' [allowFiltering]='true' (resizeStop)="onResize271($event)"
                                [pageSettings]='initialPage' [filterSettings]='filterSettings'
                                (dataStateChange)='dataStateChange271($event)' (actionBegin)="onActionComplete271($event)"
                                [showColumnChooser]='true'>
                                <e-columns>
                            
                                    <!-- Company -->
                                    <e-column field="fileName" headerText="File Name" width=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                  
                                    <!-- TransactionId -->
                                    <e-column field="companyName" headerText="Company Name" width=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="ediError" headerText="271 Error" width=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="edI_Status" headerText="File Status" width=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="transactionStatus" headerText="Transaction Status" width=100 type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="createdTime" headerText="Created Time" width=100 type="date" [format]='formatOptions'>                            
                                    </e-column>
                                    <e-column field="transactionDateTime" headerText="Transaction Date" width=100 type="date" [format]='formatOptions'>                                       
                                    </e-column>                                 
                                    <e-column field="sftpError" headerText="File Import Error" width="100"
                                            textAlign='center' [allowEditing]='false' type='string' [allowSorting]='false'
                                            [allowFiltering]="false">
                                            <ng-template #template let-data>
                                                <button class="btn btn-edit-table text-center" data-bs-toggle="modal"
                                                    *ngIf="data.sftpError!=null && data.sftpError!=undefined && data.sftpError!=''"
                                                    data-bs-target="#showError"
                                                    (click)="getError(data.sftpError)">View</button>&nbsp;
                                            </ng-template>
                                        </e-column>                        
                                    <!--------------------------------table header icon---------------->
                                    <e-column width="50" [showInColumnChooser]='false'>
                                        <ng-template #headerTemplate let-data>
                                            <div>
                                                <span id='show' (click)='showorhidecolumns271()'><i class="fa fa-cog fa-lg"
                                                        aria-hidden="true"> </i></span>
                                            </div>
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                            <div *ngIf="Eligibility271Data.length == 0  && global.globalAgencyId != 0" class="text-center"
                                style="color:red">
                                <p>No data available</p>
                            </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              
           
        </div>
    </div>
</div>


<span id="openError" data-bs-toggle="modal" data-bs-target="#showError"></span>
<div class="modal hide fade modalbackgrod" id="showError" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Error </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-12 ">
                        <textarea class="form-control" style="height: 256px;" [disabled]="true" [(ngModel)]="eligibilityLogsError"></textarea>

                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>